<template>
  <div class="page bg-color">
    <van-sticky>
      <div class="header-box">
        <div class="tabNav-container" ref="tabWrap">
          <div class="tabNav1">
            <div v-for="(tab, index) in tabs" :key="index" :class="{ active: active === tab.id }"
              @click="tabChange(tab.id, index)" :ref="el => tabRefs[index] = el">
              {{ tab.label }}
            </div>
          </div>
        </div>
      </div>
    </van-sticky>
    <div class="content-box">
      <!-- 进行中 顶部 -->
      <!-- <div class="position" v-if="active == 3">
        <div class="position-tabs">
          <div class="position-tabs-box">
            <div class="position-tabs-box-num1">0.00 </div>
            <div>{{ t('transaction.a9', { value: '(USD)' }) }}</div>
          </div>
          <div class="position-tabs-box">
            <div>{{ userInfo.balance_ar }}</div>
            <div>{{ t('transaction.a10', { value: '(ARS)' }) }}</div>
          </div>
          <div class="position-tabs-box">
            <div class="position-tabs-box-num2" style="color: rgb(132, 207, 136);">0.00 </div>
            <div>{{ t('transaction.a11', { value: '(USD)' }) }}</div>
          </div>
        </div>
      </div> -->
      <!-- 列表 -->
      <van-list v-model:loading="loading" :finished="finished" :loading-text="t('loading.a1')"
        :finished-text="t('loading.a2')" @load="onLoad">
        <!-- otc -->
        <div class="card" v-if="active == 0">
          <div class="item item2" v-for="v in list2">
            <div class="title">
              <div class="title-item">
                <div class="left">
                  <div class="title-name">{{ v.stock_name }}</div>
                </div>
                <div class="right color-0068FF dq-box" style="flex-shrink: 0;">
                  <span class="color-00cb0a" v-if="v.status == 3">{{ t('transaction.a47') }}</span>
                  <span v-if="v.status == 4">{{ t('otc.a19') }}</span>
                </div>
              </div>
            </div>
            <div class="item2-content">
              <div class="content">
                <div class="left">{{ t('transaction.a48') }}</div>
                <div class="right">{{ v.order_sn }}</div>
              </div>
              <div class="content">
                <div class="left"> {{ t('transaction.a49') }} </div>
                <div class="right">
                  <span> ${{ formatNumber(v.price_us) }} </span>
                </div>
              </div>
              <div class="content">
                <div class="left"> {{ t('transaction.a50') }} </div>
                <div class="right"> <span> {{ v.number }} </span> </div>
              </div>
              <div class="content">
                <div class="left"> {{ t('transaction.a51') }} </div>
                <div class="right">
                  <span> ${{ v.total_price }} </span>
                </div>
              </div>
              <div class="content">
                <div class="left"> {{ t('transaction.a52') }} </div>
                <div class="right">
                  <span> ${{ v.paid_price }} </span>
                </div>
              </div>
              <div class="content">
                <div class="left"> {{ t('transaction.a53') }} </div>
                <div class="right">
                  <span> ${{ v.pending_price }} </span>
                </div>
              </div>
              <div class="content">
                <div class="left"> {{ t('transaction.a54') }} </div>
                <div class="right">
                  <span> ${{ ((Number(v.market_price) - Number(v.price)) * Number(v.number)).toFixed(2) }} </span>
                </div>
              </div>
              <div class="content">
                <div class="left">{{ t('transaction.a55') }}</div>
                <div class="right"><span>{{ v.task_start_time }}</span></div>
              </div>
              <div class="content">
                <div class="left">{{ t('transaction.a56') }}</div>
                <div class="right"><span>{{ v.task_end_time }}</span></div>
              </div>
            </div>
            <div class="btn-box" v-if="v.status == 3 && isExpired(v.task_end_time)">
              <van-button class="btn" @click="otcSellClick(v)" :loading="v.btnLoading" :loading-text="t('loading.a6')"
                size="small"> {{ t('transaction.a57') }} </van-button>
            </div>
          </div>
        </div>
        <!-- ipo -->
        <template v-if="active == 1">
          <div class="card">
            <div class="item item2" v-for="(item, index) in list1" :key="index">
              <div v-if="item.status == 4">
                <div class="title">
                  <div class="title-item">
                    <div class="left">
                      <div class="title-name" style="display: flex;">
                        <div class="market">US</div>
                        <div style="font-weight: normal;font-size: 13px;">{{ item.stock_name }}</div>
                      </div>
                    </div>
                    <div class="right" style="font-weight: 600;">
                      <span>{{ getOrderStatusText(item.status) }}</span>
                    </div>
                  </div>
                </div>
                <div class="item2-content">
                  <div class="content">
                    <div class="left"> {{ t('ipo.a27') }} </div>
                    <div class="right"><span>{{ item.order_sn }}</span></div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a30') }} </div>
                    <div class="right">
                      <span>$ {{ formatNumber(item.price_us) }}</span>
                    </div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a31') }} </div>
                    <div class="right"><span> {{ item.sub_number }}</span></div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a32') }} </div>
                    <div class="right">
                      <span>$ {{ formatNumber(item.total_price_us) }}</span>
                    </div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a33') }} </div>
                    <div class="right">
                      <div class="eur color-0068FF">${{ formatNumber(item.income_price) }}</div>
                    </div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a34') }} </div>
                    <div class="right">
                      <div class="eur"> {{ item.sell_time }} </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="title">
                  <div class="title-item">
                    <div class="left">
                      <div class="title-name" style="display: flex;">
                        <div class="market">US</div>
                        <div style="font-weight: normal;font-size: 13px;">{{ item.stock_name }}</div>
                      </div>
                    </div>
                    <div class="right" style="font-weight: 600;">
                      <span>{{ getOrderStatusText(item.status) }}</span>
                    </div>
                  </div>
                </div>
                <div class="item2-content">
                  <div class="content">
                    <div class="left"> {{ t('ipo.a27') }} </div>
                    <div class="right"><span>{{ item.order_sn }}</span></div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a30') }} </div>
                    <div class="right">
                      <span>$ {{ formatNumber(item.price_us) }}</span>
                    </div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a31') }} </div>
                    <div class="right"><span>{{ item.sub_number }}</span></div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a32') }} </div>
                    <div class="right">
                      <span>$ {{ formatNumber(item.total_price_us) }}</span>
                    </div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a10') }} </div>
                    <div class="right">
                      <div class="eur color-0068FF">$ {{ formatNumber(item.interest_rate * item.sub_number *
                        item.price_us)
                      }}</div>
                    </div>
                  </div>
                  <div class="content">
                    <div class="left"> {{ t('ipo.a34') }} </div>
                    <div class="right">
                      <div class="eur">{{ item.sell_time }}</div>
                    </div>
                  </div>
                </div>
                <div class="btn-box">
                  <van-button class="btn" v-if="isExpiredArgentina(item.sell_time)" @click="shuHui(item)"
                    :loading="item.btnLoading" :loading-text="t('loading.a5')" size="small">{{ t('ipo.a44')
                    }}</van-button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- etf -->
        <!-- <div class="item" v-if="active == 2">
          <div class="flex">
            <div style="word-break: break-all; width: 50%;">
              <div class="title">QT32085577314609100137260</div>
            </div>
            <div><span class="hbl">{{ t('transaction.a28') }} 175.00%</span></div>
          </div>
          <div class="flex time-box">
            <div>
              <div>{{ t('transaction.a29') }}</div>
              <div style="color: #000;">01-10-2025 02:05:09</div>
            </div>
            <div><img src="@/assets/images/time.png" alt="" class="icon"></div>
            <div style="text-align: right;">
              <div>{{ t('transaction.a30') }}</div>
              <div style="color: #000;">05-11-2025 02:05:09</div>
            </div>
          </div>
          <div class="flex-col box">
            <div class="flex">
              <div>{{ t('transaction.a31') }}</div>
              <div>FICripto - GS</div>
            </div>
            <div class="flex">
              <div>{{ t('transaction.a32') }}</div>
              <div>5,000.00 $</div>
            </div>
            <div class="flex">
              <div>{{ t('transaction.a33') }}</div>
              <div>250.00 $</div>
            </div>
            <div class="flex">
              <div>{{ t('transaction.a34') }}</div>
              <div>5.00%</div>
            </div>
            <div class="flex">
              <div>{{ t('transaction.a35') }}</div>
              <div>8,750.00 $</div>
            </div>
            <div class="flex">
              <div>{{ t('transaction.a36') }}</div>
              <div>175.00%</div>
            </div>
            <div class="flex">
              <div>{{ t('transaction.a37') }}</div>
              <div>35</div>
            </div>
            <div class="flex">
              <div>狀態</div>
              <div class="color-f79a49">交易中</div>
            </div>
          </div>
        </div> -->
        <!-- tab 切换 -->
        <div class="list-page-tabs" v-if="active == 3">
          <div class="list-page-tabs-item" :class="{ selected: active2 == 0 }" @click="tabChange2(0)"> {{ t('index.a29')
          }}
          </div>
          <div class="list-page-tabs-item" :class="{ selected: active2 == 1 }" @click="tabChange2(1)"> {{ t('index.a30')
          }}
          </div>
        </div>
        <!-- 股票 进行中 -->
        <template v-if="active == 3">
          <div class="list2" v-for="v in list" @click="itemClick(v)">
            <!-- <div class="typeName">US stocks</div> -->
            <div class="list-flex">
              <div class="list-flex-title1">{{ t('transaction.a21') }}</div>
              <div class="list-flex-title2">{{ t('transaction.a22', { value: `(${v.currency})` }) }}</div>
              <div class="list-flex-title3">{{ t('transaction.a23', { value: `(${v.currency})` }) }}</div>
            </div>
            <div class="list-flex list-flex-2">
              <div class="list-flex-2-tips1">{{ v.stock_name }}</div>
              <div class="list-flex-2-tips2">
                <p>{{ v.currency == 'ARS' ? Number(v.sell_price).toFixed(2) : formatNumber(v.sell_price_us) }}</p>
                <!-- <div class="yval" v-if="v.currency == 'ARS'"> ≈ {{ formatUnit('USD') }} {{
                  exchangeRateConvert(v.sell_price, rate, true) }}</div>
                <div class="yval" v-else> ≈ {{ exchangeRateConvert(v.sell_price_us, rate) }} {{ formatUnit('ARS') }}
                </div> -->
              </div>
              <div class="list-flex-2-tips3">
                <p>{{ v.currency == 'ARS' ? Number(v.price).toFixed(2) : formatNumber(v.price_us) }}</p>
                <!-- <div class="yval" v-if="v.currency == 'ARS'"> ≈ {{ formatUnit('USD') }} {{ exchangeRateConvert(v.price,
                  rate, true) }}</div>
                <div class="yval" v-else> ≈ {{ exchangeRateConvert(v.price_us, rate) }} {{ formatUnit('ARS') }}</div> -->
              </div>
            </div>
            <div class="list-flex list-flex-3">
              <div class="list-flex-3-tips1">
                <div>{{ v.currency == 'USD' ? t('transaction.a2') : t('transaction.a1') }}</div>
              </div>
              <div class="list-flex-3-tips2" v-if="Number(v.take_profit)">
                <div style="background-color: rgba(132, 207, 136,0.15); color:#84cf88;">
                  <span v-if="v.currency == 'USD'">{{ t('transaction.d2') }}{{ formatUnit(v.currency) }}{{
                    formatNumber(v.take_profit) }}</span>
                  <span v-else>{{ t('transaction.d2') }}{{ v.take_profit }}{{ formatUnit(v.currency) }}</span>
                </div>
              </div>
              <div class="list-flex-3-tips3" v-if="Number(v.stop_loss)"
                style="background-color: rgb(253, 242, 243); color: rgb(203, 0, 0);">
                <div>
                  <span v-if="v.currency == 'USD'">{{ t('transaction.d3') }}{{ formatUnit(v.currency) }}{{
                    formatNumber(v.stop_loss) }}</span>
                  <span v-else>{{ t('transaction.d3') }}{{ v.stop_loss }}{{ formatUnit(v.currency) }}</span>
                </div>
              </div>
            </div>
            <div class="list-flex list-flex-3">
              <div class="list-flex-3-tips1">
                <div>{{ v.short_name }}</div>
              </div>
              <div class="list-flex-3-tips2">
                <div style="background-color: rgb(253, 242, 243); color: rgb(203, 0, 0);"> {{ t('transaction.a24')
                }}{{ v.qty }}
                </div>
              </div>
              <div class="list-flex-3-tips3"
                :style="sunyi(v) <= 0 ? 'background-color: rgb(253, 242, 243); color: rgb(203, 0, 0);' : 'background-color: rgba(132, 207, 136,0.15); color:#84cf88;'">
                <div style="width: auto;">
                  <p> {{ t('transaction.a25') }} <span v-if="v.currency == 'USD'">{{ formatUnit(v.currency) }}</span>{{
                    v.currency == 'ARS' ?
                      (v.sell_price * v.qty).toFixed(2) : formatNumber(v.sell_price_us * v.qty)
                  }} <span v-if="v.currency == 'ARS'">{{ formatUnit(v.currency) }}</span></p>
                  <!-- <div class="yval" v-if="v.currency == 'ARS'"> ≈ {{ formatUnit('USD') }} {{
                    exchangeRateConvert((v.sell_price * v.qty).toFixed(2), rate, true) }}
                  </div>
                  <div class="yval" v-else> ≈ {{ exchangeRateConvert((v.sell_price_us * v.qty).toFixed(2), rate) }} {{
                    formatUnit('ARS') }}</div> -->
                </div>
              </div>
            </div>
            <div class="list-progress" :style="`background-color: ${sunyi(v) > 0 ? '#84cf88' : 'rgb(115, 76, 76)'};`">
              <div v-if="sunyi(v) <= 0" style="color: rgb(231, 92, 92);">{{ t('transaction.a26') }} {{ sunyi(v) }} %
              </div>
              <div v-else style="color: #fff;">{{ t('transaction.a58') }} {{ sunyi(v) }} %</div>
              <div v-if="v.stype == 1">{{ t('transaction.a27') }}</div>
              <div v-if="v.stype == 2">{{ t('transaction.d1') }}</div>
              <!-- stype 1:持仓，2：平仓 -->
            </div>
            <div class="btn-box2 " v-if="v.stype == 1">
              <div class="btn" @click.stop="stockSellOrderSubimt(v)">{{ t('transaction.a59') }}</div>
            </div>
          </div>
        </template>
        <!-- 股票 已结束 -->
        <!-- <div class="list2" v-if="active == 3" @click="router.push('/positionDetails')">
          <div class="typeName">Argentine stocks</div>
          <div class="list-flex">
            <div class="list-flex-title1">{{ t('transaction.a38') }}</div>
            <div class="list-flex-title2">{{ t('transaction.a39', { value: '(USD)' }) }} </div>
            <div class="list-flex-title3">成本(USD)</div>
          </div>
          <div class="list-flex list-flex-2">
            <div class="list-flex-2-tips1">Yuanbao, Inc. Unsponsored ADR</div>
            <div class="list-flex-2-tips2">22.22</div>
            <div class="list-flex-2-tips3">370,370.00</div>
          </div>
          <div class="list-flex list-flex-3">
            <div class="list-flex-3-tips1">
              <div>YB</div>
            </div>
            <div class="list-flex-3-tips2">
              <div style="background-color: rgb(235, 247, 246); color: rgb(0, 203, 10);"> {{ t('transaction.a40') }}
                37,000
              </div>
            </div>
            <div class="list-flex-3-tips3" style="background-color: rgb(235, 247, 246); color: rgb(0, 203, 10);">
              <div>{{ t('transaction.a41') }} 451770.00</div>
            </div>
          </div>
          <div class="list-progress" style="background: rgb(74, 110, 99);">
            <div style="color: rgb(132, 207, 136);">{{ t('transaction.a42') }} 121.97 %</div>
            <div style="background: linear-gradient(to right, rgb(255, 255, 255) 0%, rgb(60, 117, 133) 31.79%);">
              {{ t('transaction.a43') }}
            </div>
          </div>
        </div> -->
        <!-- ai订单 -->
        <template v-if="active == 4">
          <div class="card">
            <div class="item" v-for="v in list3">
              <div class="title">
                <div class="title-item">
                  <div class="left">
                    <div class="title-name" style="display: flex;">
                      <img v-if="v.level_id == 1" src="@/assets/images/ai0.png" alt="">
                      <img v-if="v.level_id == 2" src="@/assets/images/ai1.png" alt="">
                      <img v-if="v.level_id == 3" src="@/assets/images/ai2.png" alt="">
                      <img v-if="v.level_id == 4" src="@/assets/images/ai3.png" alt="">
                      <span>{{ v.level_id }}.0 Version</span>
                    </div>
                  </div>
                  <div class="right" style="font-weight: 600;"><span class="status-pending">{{ t('transaction.a60')
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="content">
                <div class="left">{{ t('dayTrading.a9') }}</div>
                <div class="right"><span>{{ v.order_sn }}</span></div>
              </div>
              <div class="content">
                <div class="left">{{ t('dayTrading.a12') }}</div>
                <div class="right">
                  <div style="color: rgb(0, 60, 210);">${{ v.price }}</div>
                  <!-- <div class="yval"> ≈ ${{ exchangeRateConvert(v.price, rate, true) }} </div> -->
                </div>
              </div>
              <!-- <div class="content">
                  <div class="left">锁仓时间</div>
                  <div class="right"><span>2025-20-25 12:05:06</span></div>
                </div> -->
              <div class="content">
                <div class="left">{{ t('transaction.a61') }}</div>
                <div class="right"><span>{{ v.day_cycle }} {{ t('transaction.a62') }}</span></div>
              </div>
              <div class="content">
                <div class="left">{{ t('transaction.a63') }}</div>
                <div class="right">
                  <span style="color: rgb(0, 60, 210);"$>{{ v.profit_forecast }}</span>
                  <!-- <div class="yval"> ≈ ${{ exchangeRateConvert(v.profit_forecast, rate, true) }} </div> -->
                </div>
              </div>
              <div class="content">
                <div class="left">{{ t('transaction.a64') }}</div>
                <div class="right"><span>{{ v.over_at }}</span></div>
              </div>
              <div class="content">
                <div class="left">{{ t('transaction.a65') }}</div>
                <div class="right"><span>{{ v.created_at }}</span></div>
              </div>
            </div>
          </div>
        </template>
      </van-list>
    </div>
  </div>
</template>

<script setup name="transactionPage">
import { send } from '@/ws'
import { useIndexWS } from '@/composables/useIndexWS'
import { usePolling } from "@/hooks/usePolling"
import { formatUnit, exchangeRateConvert, formatNumber, isExpiredArgentina } from "@/utils/globalMethods"
import { showToast, showSuccessToast, showConfirmDialog } from 'vant';
import { otcList, otcSell, daytradingList, stockOrder, stockSellOrder, ipoList, stockPrice, ipoSellApi } from "@/api"
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n"
import { useMainStore } from "@/store"

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const mainStore = useMainStore()
const rate = computed(() => mainStore.rate)

const userInfo = ref({})
function getUserInfo() {
  mainStore.getUserInfo().then(data => {
    userInfo.value = data
  })
}
getUserInfo()

// ipo订单列表
function getOrderList() {
  ipoList({
    page: page.value,
    size: size.value,
    type: 2 // 0待中签 1已中签 2交易明细 3已驳回
  }).then(res => {
    if (res.code == 200) {
      list1.value = list1.value.concat(res.data.list)
      list1.value = list1.value.map(v => {
        return {
          ...v,
          btnLoading: false
        }
      })
      loading.value = false;
      page.value++
      if ((res.data.stockInfo?.length || 0) < size.value) {
        finished.value = true;
      }
    }
  })
}

// const value = ref('');
// const onSearch = (val) => console.log(val);
// const onClickButton = (value) => console.log(value.value);

const active = ref(route.query.type || 4)
const tabs = [
  { id: 4, label: t('transaction.a44') },
  { id: 0, label: t('transaction.a45') },
  { id: 1, label: 'IPO' },
  { id: 2, label: 'ETF' },
  { id: 3, label: t('transaction.a46') },
]
const active2 = ref(0)

function tabChange(e, index) {
  list.value = []
  list2.value = []
  list3.value = []
  list1.value = []
  // stock_symbolList = []
  active.value = e
  page.value = 1
  loading.value = false
  finished.value = false
  scrollActiveToCenter(index)
}
function tabChange2(e) {
  list.value = []
  list2.value = []
  list3.value = []
  list1.value = []
  active2.value = e
  page.value = 1
  loading.value = false
  finished.value = false
}

//列表
const list = ref([]);
const list2 = ref([])
const list3 = ref([])
const list1 = ref([])
const loading = ref(false);
const finished = ref(false);
const page = ref(1)
const size = ref(20)

const onLoad = () => {
  if (active.value == 0) {
    getOtcList()
  } if (active.value == 4) {
    getAi()
  } if (active.value == 3) {
    getStockOrder()
  } else if (active.value == 1) {
    getOrderList()
  } else {
    finished.value = true;
  }
};

// ai
function getAi() {
  daytradingList({
    page: page.value,
    size: size.value,
    type: 0
  }).then(res => {
    if (res.code == 200) {
      list3.value = list3.value.concat(res.data.list)
      loading.value = false;
      page.value++
      if (res.data.list.length < size.value) {
        finished.value = true;
      }
    }
  })
}
// otc
function getOtcList() {
  otcList({
    page: page.value,
    size: size.value,
    type: 5
  }).then(res => {
    if (res.code == 200) {
      list2.value = list2.value.concat(res.data.list)
      list2.value = list2.value.map(v => {
        return {
          ...v,
          btnLoading: false
        }
      })
      loading.value = false;
      page.value++
      if (res.data.list.length < size.value) {
        finished.value = true;
      }
    }
  })
}
// 赎回
function otcSellClick(v) {
  showConfirmDialog({
    title: t('transaction.a66'),
    showCancelButton: true,
    confirmButtonColor: "#2969ff",
    confirmButtonText: t('transaction.a67'),
    cancelButtonText: t('transaction.a68'),
    message:
      t('transaction.a69'),
  })
    .then(() => {
      v.btnLoading = true
      otcSell({
        id: v.id
      }).then(res => {
        if (res.code == 200) {
          showSuccessToast(res.message)
          tabChange(active.value)
        }
      }).finally(() => {
        v.btnLoading = false
      })
    })
}
// otc end
// 单股票
function getStockOrder() {
  stockOrder({
    page: page.value,
    size: size.value,
    // type: active2.value == 0 ? 'ARS' : 'USD'  // ARS USD
    stype: active2.value + 1
  }).then(res => {
    if (res.code == 200) {
      list.value = list.value.concat(res.data.list)
      // stock_symbolList = list.value
      //   .filter(v => v.stype !== 2)
      //   .map(v => v.stock_symbol)
      loading.value = false;
      page.value++

      if (res.data.list.length < size.value) {
        finished.value = true;
      }
    }
  })
}
// 单股卖出
function stockSellOrderSubimt(v) {
  showConfirmDialog({
    title: t('transaction.a70'),
    showCancelButton: true,
    confirmButtonColor: "#2969ff",
    confirmButtonText: t('transaction.a67'),
    cancelButtonText: t('transaction.a68'),
    message:
      t('transaction.a71'),
  })
    .then(() => {
      stockSellOrder({
        id: v.id
      }).then(res => {
        if (res.code == 200) {
          showSuccessToast(res.message)
          tabChange(active.value)
        }
      })
    })
}
// ipo赎回
const shuHui = (item) => {
  item.btnLoading = true
  ipoSellApi({
    id: item.id
  }).then(res => {
    if (res.code == 200) {
      tabChange()
      setTimeout(() => {
        showSuccessToast(res.message)
      }, 20)
    }
  }).finally(() => {
    item.btnLoading = false
  })
}
// 损益计算
function sunyi(v) {
  if (v.currency == 'USD') {
    return ((Number(v.sell_price_us) - Number(v.price_us)) / Number(v.price_us) * 100).toFixed(2)
  } else {
    return ((Number(v.sell_price) - Number(v.price)) / Number(v.price) * 100).toFixed(2)
  }
}

function isExpired(expireTime) {
  if (!expireTime) return false;

  // 兼容格式: 15-12-2025 18:00:00
  const parts = expireTime.split(" ");
  const datePart = parts[0]; // 15-12-2025
  const timePart = parts[1] || "00:00:00";

  const [dd, mm, yyyy] = datePart.split("-");

  // 转换为标准格式 YYYY-MM-DD HH:mm:ss
  const standardTime = `${yyyy}-${mm}-${dd} ${timePart}`;

  const expire = new Date(standardTime).getTime();
  const now = Date.now();

  if (isNaN(expire)) {
    console.error("无效时间格式:", expireTime);
    return false;
  }
  return now > expire; // true = 已过期
}

const getOrderStatusText = (status) => {
  const statusMap = {
    0: t('ipo.a37'),
    1: t('ipo.a38'),
    2: t('ipo.a38'),
    3: t('ipo.a39'),
    4: t('ipo.a40'),
    5: t('ipo.a41')
  };
  return statusMap[status];
};

const itemClick = (v) => {
  if (v.stype == 1) {
    router.push('/marketDetail?id=' + v.stock_id)
  }
}

// 获取最新价格
// let stock_symbolList = []
// function getStockPrice() {
//   if (stock_symbolList.length <= 0) {
//     return
//   }
//   stockPrice({
//     stock_symbol: stock_symbolList
//   }).then(res => {
//     if (res.code == 200) {
//       if (active.value == 3) {  //单股
//         list.value.forEach((v) => {
//           if (res.data[v.stock_symbol] && v.stype !== 2) {
//             if (v.currency == 'USD') {
//               v.sell_price_us = res.data[v.stock_symbol]
//             } else {
//               v.sell_price = res.data[v.stock_symbol]
//             }
//           }
//         })
//       }
//     }
//   })
// }
// const { start, stop } = usePolling(() => {
//   return getStockPrice()
// }, 2000)  // 3 秒轮询一次
// start()


// 监听 股票列表 订阅价格
let webSocketSendSubs = []
watch(list, (newVal, oldVal) => {
  // console.log(newVal);
  if (newVal.length) {
    if (active.value == 3) {
      webSocketSendSubs = newVal.map(v => {
        return { type: 'stock', symbol: v.short_name, country: v.country || 'US' }
      })
    } else {
      webSocketSendSubs = []
    }
    send({
      action: 'subscribe',
      subs: webSocketSendSubs
    })
  }
})
// ===== 初始化 WebSocket =====
let offWS = null
const initWebSocket = () => {
  offWS = useIndexWS({
    action: 'subscribe',
    subs: []
  }, res => {
    // console.log(res, '////');
    // 股票
    if (res.type == 'stock') {
      list.value.forEach(v => {
        if (v.short_name == res.data.symbol && v.country == res.data.co) {
          if (v.currency == 'USD') {
            v.sell_price_us = res.data.c
          } else {
            v.sell_price = res.data.c
          }
        }
      })
    }
  })
}
initWebSocket()
onBeforeUnmount(() => {
  offWS && offWS()
})

// tab自动滚动

//  自动滚动到中间
const tabWrap = ref(null)
const tabRefs = ref([])
function scrollActiveToCenter(index) {
  const wrap = tabWrap.value
  const tab = tabRefs.value[index]
  if (!wrap || !tab) return

  const wrapWidth = wrap.clientWidth
  const tabWidth = tab.offsetWidth
  const tabLeft = tab.offsetLeft

  // 目标滚动位置 = tab 的中心点 - 容器宽度的一半
  const targetScrollLeft = tabLeft - (wrapWidth / 2) + (tabWidth / 2)

  wrap.scrollTo({
    left: targetScrollLeft,
    behavior: 'smooth'
  })
}
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 75px;
  min-height: 100vh;

  .header-box {
    padding: 0px 24px;
    background: #fff;
    border-radius: 0 0 24px 24px;

    .top-box {
      display: flex;
      align-items: center;

      .van-search {
        background-color: #fff;
        padding: 10px 0;
        flex: 1;
      }

      :deep(.van-search__content) {
        background: #f6f9ff;
      }
    }

    .tabNav-container {
      padding-top: 15px;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      .tabNav1 {
        display: flex;
        color: #000;
        font-size: 14px;
        gap: 20px;
        width: -moz-max-content;
        width: max-content;
        padding-bottom: 10px;
        align-items: center;

        .active {
          border-radius: 14px;
          background: #e5ebfb;
          padding: 6px 10px;
          color: #2969ff;
          font-weight: 500;
        }
      }

      .tabNav2 {
        display: flex;
        color: #000;
        font-size: 12px;
        gap: 20px;
        width: -moz-max-content;
        width: max-content;
        padding-bottom: 10px;
        align-items: center;

        .active {
          padding: 6px 0;
          margin: 0 5px;
          color: #2969ff;
          font-weight: 500;
          border-bottom: 1px solid #2969ff;
        }
      }
    }
  }

  .content-box {
    padding: 0 20px;



    .item {
      background: #fff;
      border-radius: 6px;
      margin-top: 16px;
      padding: 15px 12px 12px;
      font-size: 13px;

      .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &>div:first-child {
          color: #a2a7b2;
        }
      }

      .title {
        color: #000;
        font-weight: 700;
      }

      .hbl {
        padding: 4px 10px;
        color: #269300;
        font-size: 12px;
        background: #f6f9ff;
      }

      .time-box {
        background: #f6f7fd;
        border-radius: 4px;
        margin: 12px 0;
        padding: 11px 16px;
        color: #a2a7b2;
      }

      .icon {
        width: 13px;
        height: 13px;
      }

      .flex-col {
        display: flex;
        flex-direction: column;
      }

      .box {
        border-radius: 4px;
        background: #f6f7fd;
        gap: 8px;
        padding: 12px 16px;
      }
    }

    .position {
      font-size: 16px;
      margin-top: 16px;

      .position-tabs {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 9px;

        .position-tabs-box {
          flex: 1;
          background-color: #fff;
          padding: 10px;
          text-align: center;
          border-radius: 4px;
          min-height: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          div {
            font-size: 13px;
            color: #000;
            font-weight: 700;
          }

          div+div {
            font-size: 11px;
            margin-top: 6px;
            color: #999;
            font-weight: 500;
          }

          .position-tabs-box-num1 {
            color: #0068ff;
          }
        }
      }
    }

    .list2 {
      margin-top: 16px;
      border-radius: 10px;
      background: #fff;
      padding: 10px 12px;

      .typeName {
        border-radius: 4.1px;
        background: #F5F8FA;
        margin-bottom: 13px;
        display: flex;
        width: 326px;
        padding: 6px 0;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #666;
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 19px;
      }

      .list-flex {
        display: flex;
        justify-content: space-between;
        gap: 5px;

        .list-flex-title1 {
          flex: 1;
          color: #999;
          font-size: 12px;
          font-weight: 500;
        }

        .list-flex-title2 {
          flex: 1;
          color: #999;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
        }

        .list-flex-title3 {
          flex: 1;
          color: #999;
          font-size: 12px;
          font-weight: 500;
          text-align: end;
        }
      }

      .list-flex-2 {
        margin-top: 14px;

        .list-flex-2-tips1 {
          flex: 1;
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
        }

        .list-flex-2-tips2 {
          flex: 1;
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-align: center;


        }

        .list-flex-2-tips3 {
          flex: 1;
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-align: end;
        }

        .yval {
          font-size: 12px;
          color: #888c9f;
          margin-top: 3px;
          font-weight: 400;
        }
      }

      .list-flex-3 {
        margin-top: 6px;
        align-items: center;

        .list-flex-3-tips1 {
          flex: 1;

          div {
            width: fit-content;
            border-radius: 2px;
            background: #f6f6f7;
            color: #0068ff;
            font-size: 11px;
            font-weight: 500;
            padding: 5px 10px;
          }
        }

        .list-flex-3-tips2 {
          flex: 1;
          // display: flex;
          // justify-content: center;

          div {
            width: -moz-fit-content;
            width: fit-content;
            border-radius: 2px;
            font-size: 11px;
            font-weight: 500;
            padding: 5px 10px;
          }
        }

        .list-flex-3-tips3 {
          // flex: 1;
          display: flex;
          justify-content: flex-end;

          div {
            width: -moz-fit-content;
            width: fit-content;
            border-radius: 2px;
            font-size: 11px;
            font-weight: 500;
            padding: 5px 10px;

            p {
              text-align: right;
            }
          }

          .yval {
            font-size: 10px;
            color: #888c9f;
            font-weight: 400;
            padding: 0;
            text-align: right;
            width: 100%;
          }
        }
      }

      .list-progress {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* 让子元素高度一致 */
        border-radius: 20px;
        margin-top: 21px;

        div {
          // flex: 1;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          padding: 6px 0px 6px 10px;
        }

        // div+div {
        //   color: #fff;
        //   text-align: right;
        //   font-size: 12px;
        //   font-weight: 500;
        //   border-radius: 20px;
        //   border-top: 1.5px solid #fff;
        //   border-bottom: 1.5px solid #fff;
        //   border-left: 1.5px solid #fff;
        // }

        div+div {
          width: 40%;
          height: 30px;
          color: #fff;
          text-align: right;
          font-size: 12px;
          font-weight: 500;
          border-radius: 20px;
          border-top: 1.5px solid #2969ff;
          border-bottom: 1.5px solid #2969ff;
          border-left: 1.5px solid #2969ff;
          background: #2969ff;
          padding: 4px 10px;
          text-align: center;
        }
      }
    }

    // eft
    .card,
    .popup-card {
      .item {
        padding: 0 10px 20px;
        border-radius: 8px;
        opacity: 1;
        background: #fff;
        box-sizing: border-box;
        margin-bottom: 20px;

        .title {
          font-size: 13px;
          margin-top: 5px;
          font-family: Alibaba PuHuiTi 2;
          line-height: 18px;
          letter-spacing: 0;
          padding: 10px 0px;
          border-radius: 8px 8px 0 0;
          color: #000;

          .title-item {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .title-name {
              display: flex;
              align-items: center;
              gap: 5px;
              color: #000;
              font-family: "Microsoft YaHei UI";
              font-size: 14px;
              font-style: normal;
              font-weight: 700;
              line-height: 19px;

              img {
                width: 30px;
                height: 30px;
              }
            }

            .right {
              text-align: right;
            }
          }

        }

        .content {
          display: flex;
          justify-content: space-between;
          margin-top: 12px;
          font-family: Alibaba PuHuiTi 2;
          font-size: 13px;
          line-height: 18px;
          letter-spacing: 0;
          color: #000;

          &:first-child {
            margin-top: 0;
          }

          .left {
            max-width: 70%;
            overflow-wrap: break-word;
          }

          .right {
            max-width: 70%;
            text-align: right;

            .yval {
              font-size: 11px;
              color: #888c9f;
              margin-top: 3px;
            }
          }
        }
      }

      .item2 {
        padding: 0;

        .item2-content {
          padding: 20px 0;
        }
      }

      .item {
        padding: 15px;
      }
    }

    .market {
      height: 18px;
      border-radius: 2px;
      padding: 0 3px;
      background: #2969ff;
      color: #fff;
      margin-right: 5px;
    }

    .color-0068FF {
      color: #0068ff;
    }

    .color-f79a49 {
      color: #f79a49;
    }

    .color-15B384 {
      color: #15b384;
    }

    .color-CB0000 {
      color: #cb0000;
    }

    .color-ed1c24 {
      color: #ed1c24;
    }

    .status-pending {
      color: #faad14;
    }

    .status-dismissed {
      color: #ff4d4f;
    }

    .color-00cb0a {
      color: #00cb0a;
    }

  }

  .dq-box {
    display: flex;
    gap: 4px;
    align-items: center;


    .dq {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background: #E2E2E2;
      padding: 2px 4px;
      gap: 2px;
      color: #666;

      img {
        width: 12px;
        height: 12px;
      }
    }

    &.km {
      .dq {
        background: #00982A;
        color: #fff;

        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}

// tab
.list-page-tabs {
  font-family: Inter;
  font-size: 14px;
  color: #000;
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 15px;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  .list-page-tabs-item {
    padding: 5px 15px;
    box-sizing: border-box;
    color: #2969ff;
    background: #fff;
    border-radius: 4px;
    font-size: 13px;
    border: 1px solid #2969ff;

    &.selected {
      color: #fff;
      font-weight: 500;
      background: #2969ff;
      position: relative;
    }
  }
}

// 按钮
.btn-box {
  // padding: 0 20px 0px;

  .btn {
    width: 100%;
    padding: 10px 0;
    background: #2969ff;
    color: #fff;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    border: none;
  }
}

// 按钮
.btn-box2 {
  // padding: 0 20px 0px;
  margin-top: 12px;

  .btn {
    width: 100%;
    padding: 6px 0;
    background: #2969ff;
    color: #fff;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    border: none;
  }
}
</style>
